// extracted by mini-css-extract-plugin
module.exports = {"bottomBox":"Bottom_bottomBox__3nuLS","qrcode":"Bottom_qrcode__9eCn9","map":"Bottom_map__xULc9","arrow":"Bottom_arrow__2ObVK"};